const Footer = () => {
  return (
    <footer>
      <div className="container">
        <hr />
        <div className="text-center">
          <p style={{ fontSize: 14 }}>
            Created by{" "}
            <a href="https://github.com/divyapatel01" target="_blank" rel="noreferrer">
              Divya Patel
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
